// Math shared by the Event Ops funnel cards: the "Signed up" count
// (SCRUM-449) and the percentage base the cards anchor on (SCRUM-463/487).
// Kept out of EventOps.jsx, which pulls in
// axios via Services/arndAPI.js and can't be imported into a Jest test here
// (see src/App.test.js's pre-existing ESM failure for the same reason).

/**
 * Everyone who got at least as far as signing up
 * during this event — leads (signed up, not joined) plus everyone who
 * joined (RSVP'd). `null` while leads data hasn't loaded yet, mirroring the
 * card's own '—' placeholder for that case.
 */
export const signedUpCount = (leads, joinedParents) =>
  leads ? leads.count + joinedParents : null;

/**
 * Percentage base + label for the athlete-counted cards (Signed up →
 * Purchased, SCRUM-487: f.athletes). With the meet's athlete count set on
 * the event (Events.athleteCount, SCRUM-489) every one of them is a share of it, Signed up and
 * RSVPs included (`aboveRsvp`). Without it, the cards after RSVPs are
 * shares of RSVP'd athletes, and Signed up / RSVPs show no percentage.
 * QR scans and Installs never get one: they count scans and devices.
 */
export const funnelBase = (f, athleteCount) =>
  athleteCount
    ? { base: athleteCount, baseLabel: 'of athletes', aboveRsvp: true }
    : { base: f.athletes.rsvp, baseLabel: 'of RSVPs', aboveRsvp: false };
